import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage if available (fallback for cross-domain cookie issues)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("bl_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(e) {
  const status = e?.response?.status;
  const d = e?.response?.data?.detail;
  if (d) {
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
    return String(d);
  }
  // Friendly translations when the ingress or CDN swallows our detail body
  if (status === 402) return "Your AI credits are exhausted. Top up your Emergent Universal Key balance (Profile → Manage plan → Universal Key → Add Balance) and try again.";
  if (status === 413) return "File is too large for the upload pipeline. Try a smaller file (under ~25 MB) or paste the text directly.";
  if (status === 502 || status === 503 || status === 504) return "The server is temporarily unavailable. Please retry in a moment.";
  if (status === 524) return "The request took too long and timed out at the edge. Try a smaller file or retry.";
  if (status === 429) return "Too many requests. Slow down for a moment and try again.";
  return e?.message || "Something went wrong.";
}
